<template>
  <div>
    <back-btn/>
    <div class="d-flex justify-space-between align-center mb-3">
      <v-card-title class="pa-0">{{ isUpdate ? 'Изменить' : 'Создать' }} филиал</v-card-title>
      <v-btn color="primary" @click="changePasswordDialog = true" v-if="isUpdate">Изменить пароль</v-btn>
    </div>
    <v-card>
      <v-card-text>
        <validation-observer v-slot="{handleSubmit}" ref="formObs">
          <form @submit.prevent="handleSubmit(save)">
            <v-card-title class="px-0">Филиал инфо</v-card-title>
            <v-row class="form-dialog-modal">
              <v-col sm="6" cols="12" lg="3">
                <custom-autocomplete
                    clearable
                    label="Родитель"
                    :items="mkos"
                    v-model="formData.parent_id"
                ></custom-autocomplete>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required"
                    label="Бренд"
                    vid="name"
                    v-model="formData.name"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required"
                    label="Название фирмы"
                    vid="company_name"
                    v-model="formData.company_name"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Номер телефона"
                    prefix="998"
                    pattern="##-###-##-##"
                    rules="required|phone"
                    vid="phone"
                    v-model="formData.phone"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required|email"
                    label="Email"
                    vid="email"
                    v-model="formData.email"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3" v-if="!isUpdate">
                <custom-input-text
                    label="Пароль для входа"
                    vid="password"
                    :rules="{
                      min: 6,
                      required: !isUpdate
                    }"
                    type="password"
                    v-model="formData.password"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    rules="required"
                    label="Адрес"
                    v-model="formData.address"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Телеграм"
                    v-model="formData.telegram_channel"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Допольнительная информация"
                    v-model="formData.info"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Директор"
                    rules="required"
                    vid="director"
                    v-model="formData.director"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <validation-provider name="Лого" v-slot="{errors}" v-if="typeof formData.logo !== 'string'">
                  <v-file-input
                      label="Лого"
                      v-model="formData.logo"
                      :error-messages="errors[0]"
                  ></v-file-input>
                </validation-provider>
                <v-sheet v-else style="position:relative;" width="100" height="100" class="mb-2">
                  <v-img class="circle-radius" max-width="100" height="100" :src="formData.logo_url"></v-img>
                  <!--              <v-sheet class="primary pl-2 pr-8 py-2 d-flex border-radius-5 white&#45;&#45;text align-center pos-r" v-else>-->
                  <!--                <span>{{ formData.logo }}</span>-->
                  <!--                <v-btn @click="formData.logo = null" dark icon class="v-btn&#45;&#45;absolute v-btn&#45;&#45;right">-->
                  <!--                  <v-icon small>fas fa-times</v-icon>-->
                  <!--                </v-btn>-->
                  <!--              </v-sheet>-->
                  <v-btn style="left: 35px" @click="formData.logo = null" color="error" icon absolute bottom small>
                    <v-icon x-small>fas fa-times</v-icon>
                  </v-btn>
                </v-sheet>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    only="number"
                    label="PAYMO терминал"
                    rules="required"
                    vid="seller_id"
                    v-model="formData.seller_id"
                ></custom-input-text>
              </v-col>
            </v-row>

            <v-card-title class="px-0">Банковские данные</v-card-title>
            <v-row class="form-dialog-modal">
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Банк"
                    rules="required"
                    v-model="formData.bank"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="ИНН"
                    rules="required"
                    v-model="formData.inn"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="МФО"
                    rules="required"
                    v-model="formData.mfo"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Расчетный счет"
                    v-model="formData.payment_account"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="Номер договора с филиалом"
                    v-model="formData.document_number"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <validation-provider vid="document" name="Договор" v-slot="{errors}"
                                     v-if="typeof formData.document !== 'string'">
                  <v-file-input
                      label="Договор"
                      v-model="formData.document"
                      :error-messages="errors[0]"
                  />
                </validation-provider>
                <div v-else class="d-flex align-center">
                  <v-btn icon @click="formData.document =null">
                    <v-icon>fas fa-times</v-icon>
                  </v-btn>
                  <downloader file-name="Документ договора" :link="formData.document_url"/>
                  <!--                <v-sheet v-else style="position:relative;" width="100" height="100" class="mb-2">-->
                  <!--                  <v-img class="circle-radius" max-width="100" height="100" :src="formData.logo_url"></v-img>-->
                  <!--                  <v-btn style="left: 35px" @click="formData.logo = null" color="error" icon absolute bottom small>-->
                  <!--                    <v-icon x-small>fas fa-times</v-icon>-->
                  <!--                  </v-btn>-->
                  <!--                </v-sheet>-->
                </div>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="EPOS Merchant"
                    v-model="formData.merchant_id"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="EPOS Terminal"
                    v-model="formData.terminal_id"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="HUMO Merchant"
                    v-model="formData.humo_merchant"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                    label="HUMO Terminal"
                    v-model="formData.humo_terminal"
                ></custom-input-text>
              </v-col>
            </v-row>
            <v-card-title class="px-0">Цена и возможности филиала</v-card-title>
            <v-row dense>
              <v-col sm="6" cols="12" lg="3">
                <v-checkbox
                    class="ma-0"
                    v-model="formData.can_scoring"
                    true-value="1"
                    false-value="0"
                    label="Запрос на PAYMO скоринг"
                ></v-checkbox>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <v-checkbox
                    class="ma-0"
                    true-value="1"
                    false-value="0"
                    v-model="formData.can_katm_info"
                    label="Запрос на KATM (История кредита)"
                ></v-checkbox>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <v-checkbox
                    class="ma-0"
                    true-value="1"
                    false-value="0"
                    v-model="formData.can_katm_salary"
                    label="Запрос на KATM (сведение о дохадах)"
                ></v-checkbox>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-autocomplete
                    :items="katmUsers"
                    clearable
                    label="KATM пользватель"
                    v-model="formData.katm_user_id"
                ></custom-autocomplete>
              </v-col>
<!--              <v-col sm="6" cols="12" lg="3">-->
<!--                <v-checkbox-->
<!--                    class="ma-0"-->
<!--                    v-model="formData.is_subscription"-->
<!--                    true-value="1"-->
<!--                    false-value="0"-->
<!--                    label="Ежемесячная подписка"-->
<!--                ></v-checkbox>-->
<!--              </v-col>-->
              <v-col sm="6" cols="12" lg="3">
                <money-input
                    rules="required"
                    label="Цена за скоринг"
                    v-model="formData.price_katm_scoring"
                ></money-input>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <money-input
                    rules="required"
                    label="Цена за KATM (История кредита)"
                    v-model="formData.price_katm_info"
                ></money-input>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <money-input
                    rules="required"
                    label="Цена за KATM (сведение о дохадах)"
                    v-model="formData.price_katm_salary"
                ></money-input>
              </v-col>
<!--              <v-col sm="6" cols="12" lg="3">-->
<!--                <money-input-->
<!--                    label="Цена ежемесячной подписки"-->
<!--                    v-model="formData.price_subscription"-->
<!--                ></money-input>-->
<!--              </v-col>-->
              <v-col sm="6" cols="12" lg="3">
                <money-input
                    rules="required"
                    label="Цена за активный кредит (с картой)"
                    v-model="formData.price_active_credit"
                ></money-input>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <money-input
                    rules="required"
                    label="Цена за активный кредит (без карты)"
                    v-model="formData.price_active_credit_cash"
                ></money-input>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <money-input
                    rules="required"
                    label="Цена на запрос в Налоговый"
                    v-model="formData.price_tax"
                ></money-input>
              </v-col>



              <v-col sm="6" cols="12" lg="3">
                <custom-autocomplete
                    :items="taxCanList"
                    multiple
                    item-value="value"
                    label="Запрос на Налоговой"
                    v-model="formData.can_tax"
                ></custom-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                  label="My uzcard логин"
                  v-model="formData.uzcard_login"
                ></custom-input-text>
              </v-col>
              <v-col sm="6" cols="12" lg="3">
                <custom-input-text
                  label="My uzcard пароль"
                  v-model="formData.uzcard_pass"
                ></custom-input-text>
              </v-col>


              <v-col cols="12" class="text-right">
                <v-btn type="submit" width="100%" color="primary" :loading="loading">Сохранить</v-btn>
              </v-col>
            </v-row>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>

    <v-dialog v-if="isUpdate" v-model="changePasswordDialog" width="500">
      <v-card>
        <v-card-title class="mb-3">Изменить праоль</v-card-title>
        <v-card-text>
          <validation-observer v-slot="{handleSubmit}" ref="changePasswordFormObs">
            <form @submit.prevent="handleSubmit(changePassword)">
              <custom-input-text
                  rules="required"
                  label="Пароль"
                  v-model="credentialFormData.password"
                  type="password"/>
              <custom-input-text
                  label="Введите пароль еще раз"
                  v-model="credentialFormData.confirm_password"
                  :rules="{
                    required:true,
                    min: 6,
                    confirmed:credentialFormData.password}"
                  type="password"/>
              <v-btn width="100%" color="primary" type="submit">Сохранить</v-btn>
            </form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>


<script>
import {messages, parsePhone, phoneMask} from "@/utils/constants"
import MoneyInput from "@/plugins/vuetify/components/MoneyInput";
import {clearSpace, getObjectValuesByKey, trueSetString} from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import Downloader from "@/components/ui/downloader/Downloader";


export default {
  components: {Downloader, BackBtn, MoneyInput},
  props: ['id'],
  data() {
    return {
      changePasswordDialog: false,
      loading: false,
      credentialFormData: {
        password: null,
        confirm_password: null
      },
      formData: {
        document_url: null,
        logo_url: null,
        user_id: null,
        parent_id: null,
        document: null,
        document_number: null,
        payment_account: null,
        bank: null,
        name: null,
        company_name: null,
        email: null,
        phone: null,
        password: null,
        inn: null,
        mfo: null,
        address: null,
        terminal_id: null,
        merchant_id: null,
        logo: null,
        telegram_channel: null,
        info: null,
        humo_merchant: null,
        humo_terminal: null,
        seller_id: null,
        director: null,
        can_scoring: "1",
        can_katm_info: "1",
        can_katm_salary: "1",
        is_subscription: "0",
        price_katm_scoring: "7 500",
        price_katm_info: "7 500",
        price_katm_salary: "7 500",
        price_subscription: null,
        price_active_credit: "25 000",
        price_active_credit_cash: "5 000",
        katm_user_id: null,
        price_tax: null,
        can_tax: [],
        uzcard_login: null,
        uzcard_pass: null
      },
      mkos: [],
      katmUsers: [],
      taxCanList: []
    }
  },
  computed: {
    phoneMask,
    isUpdate() {
      return !!this.id
    }
  },
  methods: {
    async getTaxCanList() {
      try {
        const {data: {data}} = await this.$http.get('admin/tax/can-list')
        this.taxCanList = data
      } catch (e) {

      }
    },
    async changePassword() {
      this.$showLoading()
      try {
        await this.$http.post(`admin/mko/change-password/${this.id}`, this.credentialFormData)
        this.changePasswordDialog = false
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs.changePasswordFormObs})
      } finally {
        this.$clearLoading()
      }
    },
    async getKatmUsers() {
      try {
        const {data: {data}} = await this.$http.get('/admin/katm-users/active')
        this.katmUsers = data
      } catch (e) {

      }
    },
    async save() {
      const formData = new FormData()
      let data = {...this.formData}
      delete data.logo_url
      delete data.document_url
      if (data.price_katm_scoring) data.price_katm_scoring = clearSpace(data.price_katm_scoring)
      if (data.price_katm_info) data.price_katm_info = clearSpace(data.price_katm_info)
      if (data.price_katm_salary) data.price_katm_salary = clearSpace(data.price_katm_salary)
      if (data.price_subscription) data.price_subscription = clearSpace(data.price_subscription)
      if (data.price_active_credit) data.price_active_credit = clearSpace(data.price_active_credit)
      if (data.price_active_credit_cash) data.price_active_credit_cash = clearSpace(data.price_active_credit_cash)
      if (data.price_tax) data.price_tax = data.price_tax = clearSpace(data.price_tax)
      if (!data.katm_user_id) data.katm_user_id = 'null'
      data.phone = parsePhone(data.phone).format('max')
      Object.entries(data).forEach(([key, value]) => {
        if (value) {
          if (key === 'logo' || key === 'document') {
            if (typeof value !== 'string') {
              formData.append(key, value)
            }
          } else if (Array.isArray(value)) {
            value.forEach(item => {
              formData.append(`${key}[]`, item)
            })
          } else {
            formData.append(key, value)
          }
        }
      })
      this.loading = true
      if (this.id) {
        await this.update(formData)
      } else {
        await this.create(formData)
      }
      this.loading = false
    },
    async update(formData) {
      try {
        formData.append('_method', 'PUT')
        await this.$http.post(`admin/mko/${this.id}`, formData)
        this.$setSuccess({text: messages.onSave})
        await this.$router.push({name: 'mko-index'})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      }
    },
    async create(formData) {
      try {
        await this.$http.post('admin/mko', formData)
        this.$setSuccess({text: messages.onSave})
        await this.$router.push({name: 'mko-index'})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      }
    },
    async getMkoData() {
      try {
        let {data: {data}} = await this.$http.get(`admin/mko/full/${this.id}`)
        data.user.phone = parsePhone(data.user.phone).format('min')
        data.phone = parsePhone(data.phone).format('min')
        data.can_katm_info = trueSetString(data.can_katm_info)
        data.can_katm_salary = trueSetString(data.can_katm_salary)
        data.can_scoring = trueSetString(data.can_scoring)
        data.is_subscription = trueSetString(data.is_subscription)
        if (data.can_tax_array) data.can_tax = data.can_tax_array
        data = getObjectValuesByKey(this.formData, data)
        this.formData = data
      } catch (e) {
        this.$setResponseError({error: e})
      }

    }
  },
  async created() {
    this.$showLoading()
    try {
      this.mkos = await this.$store.dispatch('getMkos')
      if (this.id) {
        await this.getMkoData()
      }
      await this.getKatmUsers()
      await this.getTaxCanList()
    } catch (e) {
      this.$setResponseError({error: e})
    } finally {
      this.$clearLoading()
    }


  }
}
</script>
